module.exports = __webpack_public_path__ + "static/media/play_btn_big_normal.330f0bfc.svg";